import { CloseDropEventType } from './../../app.event.type';
import { DetailNotification } from './../models/detail-notification';
import { EventTypes } from './../EventTypes';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { SharedService } from './../shared.service';
import { ListNotifications } from './../models/list-notifications';
import { TweenMax, Quint } from 'gsap';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ThemeService } from '../theme-service/theme.service';
import * as moment from 'moment';
import { Util } from '../../utils/util';
import { EAnaliseResultante, EInfracaoSituacao, PixNotification, PixNotificationType } from '../../master/pix/models/notification.model';
import { AntifraudeWarning } from '../antifraud-warning/antifraud-warning';
import { Router } from '@angular/router';
import { AntifraudWarningService } from '../../master/antifraud-warning/antifraud-warning.service';

@Component({
	selector: 'app-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class NotificationsComponent implements OnInit, OnDestroy {

	public open = true;
	public listNotifications: Array<ListNotifications> = [];
	public detailNotification: DetailNotification = new DetailNotification();
	public deleteNotification: any;
	public activeNotification = false;
	public activeTag = [];
	public isLoadingDetails: boolean;
	public isAttendant = false;
	public pixNotifications: Array<PixNotification> = [];
	public antifraudWarning: AntifraudeWarning = new AntifraudeWarning();

	constructor(
		private notificationService: SharedService, 
		private themeService: ThemeService,
		private router: Router,
		private antifraudWarningService: AntifraudWarningService) { }

	ngOnInit() {

		this.loadNotifications();

		AppEventDispatcher.listen(CloseDropEventType.CLOSE_DROP, data => {
			this.toggleBox( data.open );
		});

		AppEventDispatcher.listen(EventTypes.PROFILE.NOTIFICATIONS, data => {
			this.loadNotifications();
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CloseDropEventType.CLOSE_DROP);
		AppEventDispatcher.removeListener(EventTypes.PROFILE.NOTIFICATIONS);
	}

	async loadNotifications() {
		this.activeNotification = false;
		this.listNotifications = [];
		this.pixNotifications = [];
		this.isAttendant = this.themeService.isAttendant();

		this.getNotificationsPix();
		this.getNotificationsDefault();
	}

	getNotificationsDefault() {
		this.notificationService.getListNotifications().subscribe(data => {
			if (data && data.length > 0) {
				this.listNotifications.concat(data);
			}
			this.addTagNew();
		});
	}

	getNotificationsPix() {
		const now = new Date();
		const dataHoraInicial = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).setDate(now.getDate() - 90)).format('YYYY-MM-DDTHH:mm');
		const dataHoraFinal = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)).format('YYYY-MM-DDTHH:mm');

		this.notificationService.getListNotificationsPix(0, dataHoraInicial, dataHoraFinal, 0).subscribe(data => {
			if (data && data.Existe && data.Sucesso) {
				this.pixNotifications = Util.keysToCamel(data.Retorno) as PixNotification[];
				this.convertModelToView(this.pixNotifications.reverse());
				this.addTagNew();
			}
		});
	}

	convertModelToView(pixNotic: PixNotification[]) {
		pixNotic.forEach(notification => {
			this.listNotifications.push({
				notificationId: notification.codigoNotificacao,
				notificationList: true,
				notificationRead: notification.lida,
				messageTitle: this.getNotificationTitle(notification),
				messageContent: this.getNotificationContent(notification),
				date: moment(notification.dataNotificacao).locale('pt-BR').format('DD [de] MMM[.] YYYY [-] HH:mm'),
				dateTime: new Date(notification.dataNotificacao),
				isPix: true
			});
		});
	}

	getNotificationTitle(pixNotication: PixNotification): string {
		switch (pixNotication.tipoNotificacao) {
			case PixNotificationType.PIX_ENVIADO:
				return 'Pix enviado';
			case PixNotificationType.PIX_RECEBIDO:
				return 'Pix recebido';
			case PixNotificationType.PIX_DEVOLUCAO_ENVIADA:{
				if(this.isMedInfration(pixNotication)){
					return "Transferência em análise - Devolvida";
				}
				return 'Pix Enviado - Devolução';
			}
			case PixNotificationType.PIX_DEVOLUCAO_RECEBIDA:
				return 'Pix Recebido - Devolução';
			case PixNotificationType.PIX_REIVINDICACAO_ENVIADA:
				return 'Reivindicação de chave enviada';
			case PixNotificationType.PIX_REIVINDICACAO_RECEBIDA:
				return 'Reivindicação de chave recebida';
			case PixNotificationType.PIX_AGENDAMENTO_NAO_EFETIVADO:
				return 'Agendamento Pix não efetivado';
			case PixNotificationType.PIX_DEVOLVIDO_AGENDAMENTO_NAO_EFETIVADO:
				return 'Agendamento Pix devolução não efetivado';
			case PixNotificationType.OPEN_BANKING_CONSENTIMENTO_PAGAMENTO:
				return 'Pix Open Finance';
			case PixNotificationType.RECEBIMENTO_INFRACAO:
				if ((pixNotication.notificacaoPixRecebimentoInfracao.situacao === EInfracaoSituacao.Fechado
					&& pixNotication.notificacaoPixRecebimentoInfracao.analiseResultante === EAnaliseResultante.DISCORDAR)
					|| pixNotication.notificacaoPixRecebimentoInfracao.situacao === EInfracaoSituacao.Cancelado) {
					return "Transferência - Liberada";
				}
				if(pixNotication.notificacaoPixRecebimentoInfracao.situacao === EInfracaoSituacao.Recebida){
					return "Transferência em análise - Pix";
				}
				break;
			case PixNotificationType.TRANSACAO_PAGAMENTO_CANCELADA:
				return "Transferência em análise - Devolvida";
			case PixNotificationType.PIX_RECEBIDO_SOB_ANALISE_ANTIFRAUDE:
				return 'Transferência em análise - Pix'
			case PixNotificationType.BLOQUEIO_CAUTELAR_AUTORIZADO:
				return 'Transferência - Liberada'
			default:
				return '';
		}
	}

	getNotificationContent(notification: PixNotification): any {
		switch (notification.tipoNotificacao) {
			case PixNotificationType.PIX_ENVIADO:
				return `Você enviou ${Util.formatValue(notification.notificacaoPix.valor)} para ${notification.notificacaoPix.nome}`;
			case PixNotificationType.PIX_RECEBIDO:
				return `Você recebeu ${Util.formatValue(notification.notificacaoPix.valor)} de ${notification.notificacaoPix.nome}`;
			case PixNotificationType.PIX_DEVOLUCAO_ENVIADA:
				if(this.isMedInfration(notification)){
					return `Após a análise não foi possivel liberar o <b>Pix de ${Util.formatValue(notification.notificacaoPix.valor)}</b> 
					e o valor foi devolvido via Mecanismo especial de devolução. <br>Para mais detalhes entre em contato com nossa Central de Atendimento.`;
				}
				return `Você devolveu ${Util.formatValue(notification.notificacaoPix.valor)} para ${notification.notificacaoPix.nome}`;
			case PixNotificationType.PIX_DEVOLUCAO_RECEBIDA:
				return `Você recebeu como devolução ${Util.formatValue(notification.notificacaoPix.valor)} de ${notification.notificacaoPix.nome}`;
			case PixNotificationType.PIX_REIVINDICACAO_ENVIADA:
				return 'O seu pedido de reivindicação de chave pix teve resposta. Acesse para finalizar o processo.';
			case PixNotificationType.PIX_REIVINDICACAO_RECEBIDA:
				return 'Você recebeu um pedido de reivindicação de chave pix. Acesse para responder o pedido.';
			case PixNotificationType.PIX_AGENDAMENTO_NAO_EFETIVADO:
				return `Sua transação Pix de ${Util.formatValue(notification.notificacaoPixAgendadoNaoEfetivado.valor)} para ${notification.notificacaoPixAgendadoNaoEfetivado.nome} agendada para ${moment(notification.notificacaoPixAgendadoNaoEfetivado.dataTransacao).format('DD/MM/YYYY')} não pôde ser efetivada, pelo motivo: ${notification.notificacaoPixAgendadoNaoEfetivado.descricaoMotivo}`;
			case PixNotificationType.PIX_DEVOLVIDO_AGENDAMENTO_NAO_EFETIVADO:
				return `Sua devolução Pix de ${Util.formatValue(notification.notificacaoPixDevolvidoAgendamentoNaoEfetivado.valor)} para ${notification.notificacaoPixDevolvidoAgendamentoNaoEfetivado.nome} agendada para ${moment(notification.notificacaoPixDevolvidoAgendamentoNaoEfetivado.dataTransacao).format('DD/MM/YYYY')} não pôde ser efetivada, pelo motivo: ${notification.notificacaoPixDevolvidoAgendamentoNaoEfetivado.descricaoMotivo}`;
			case PixNotificationType.OPEN_BANKING_CONSENTIMENTO_PAGAMENTO:
				return `Você possui um Pix via Open Finance pendente de aprovação no valor de  ${Util.formatValue(notification.notificacaoOpenBankingConsentimentoPagamento.valor)}.`;
			case PixNotificationType.RECEBIMENTO_INFRACAO:
				if ((notification.notificacaoPixRecebimentoInfracao.situacao === EInfracaoSituacao.Fechado
					&& notification.notificacaoPixRecebimentoInfracao.analiseResultante === EAnaliseResultante.DISCORDAR)
					|| notification.notificacaoPixRecebimentoInfracao.situacao === EInfracaoSituacao.Cancelado) {
					return `Tudo pronto, o Pix foi analisado e está disponível em sua conta.`;
				}

				if (notification.notificacaoPixRecebimentoInfracao.situacao === EInfracaoSituacao.Recebida) {
					return `Por segurança o <b>Pix recebido de ${
						Util.formatValue(notification.notificacaoPixRecebimentoInfracao.valorBloqueado)}</b> precisa ser analisado.`
				}
				break;
			case PixNotificationType.TRANSACAO_PAGAMENTO_CANCELADA:
				return `Após a análise não foi possivel liberar o <b>Pix de ${Util.formatValue(notification.notificacaoPagamentoCancelado.valor)}</b> 
				e o valor foi devolvido via Mecanismo especial de devolução. <br>Para mais detalhes entre em contato com nossa Central de Atendimento.`
			case PixNotificationType.PIX_RECEBIDO_SOB_ANALISE_ANTIFRAUDE:
					return ` Por segurança o <b>Pix recebido de ${Util.formatValue(notification.contaNotificacaoPixTransferenciaRecebidaSobAnalise.valor)}</b> precisa ser analisado.`
			case PixNotificationType.BLOQUEIO_CAUTELAR_AUTORIZADO:
				return `Tudo pronto, o <b>Pix no valor de ${Util.formatValue(notification.contaNotificacaoBloqueioCautelarAutorizado.valor)}</b> foi analisado e está disponível em sua conta.`
		}
	}

	private isMedInfration(pixNotication: PixNotification): boolean {
		if(!pixNotication.notificacaoPix.contaNotificacaoPixTransferenciaDevolucaoEnviada)
			return false;

		return (Boolean)(pixNotication.notificacaoPix.contaNotificacaoPixTransferenciaDevolucaoEnviada.contaTransacaoDevolucao.medValorRequerido
					&& pixNotication.notificacaoPix.contaNotificacaoPixTransferenciaDevolucaoEnviada.contaTransacaoDevolucao.medResultoAnalise);
	}


	addTagNew() {
		for (let i = 0; i < this.listNotifications.length; i++) {
			const element = this.listNotifications[i];
			if (element.notificationRead === false) {
				this.activeNotification = true;
			}
			this.activeTag[element.notificationId] = !element.notificationRead;
		}
	}

	toggleBox(open) {

		this.activeNotification = false;

		if (open) {
			this.open = false;
			TweenMax.to('.box-notifications', .8, { autoAlpha: 1, top: 70, ease: Quint.easeOut });
			TweenMax.to('main .closeDrop', 0, { display: 'block' });
		} else {
			this.open = true;
			TweenMax.to('.box-notifications', .8, { autoAlpha: 0, top: 140, ease: Quint.easeOut });
			TweenMax.to('main .closeDrop', 0, { display: 'none' });
		}

		this.closeDetail();

	}

	loadDetail(notification: ListNotifications, e) {
		$('.detail-preloader').appendTo($(e.currentTarget));

		this.isLoadingDetails = true;

		if (notification.isPix) {
			const pixNotification = this.pixNotifications.find(o => o.codigoNotificacao === notification.notificationId);

			this.detailNotification = {
				pixNotification: pixNotification,
				buttonDescription: this.getDetailNotification(pixNotification.tipoNotificacao),
				buttonLink: this.getButtonLink(pixNotification.tipoNotificacao),
				date: notification.date,
				messageTitle: this.getNotificationTitle(pixNotification),
				messageContent: this.getNotificationContent(pixNotification),
				notificationId: notification.notificationId
			};

			this.activeTag[notification.notificationId] = false;
			this.openDetail();
			this.isLoadingDetails = false;

		} else {
			this.notificationService.getNotificationDetail(notification.notificationId).subscribe( data => {
				this.detailNotification = data;
				this.activeTag[notification.notificationId] = false;
				this.openDetail();
				this.isLoadingDetails = false;
			});
		}
	}

	getDetailNotification(pixNotificationType: PixNotificationType): string {
		switch (pixNotificationType) {
			case PixNotificationType.PIX_ENVIADO:
				return 'Ver extrato';
			case PixNotificationType.BLOQUEIO_CAUTELAR_AUTORIZADO:
				return 'Ver extrato';
			case PixNotificationType.PIX_RECEBIDO:
				return 'Ver extrato';
			case PixNotificationType.PIX_DEVOLUCAO_ENVIADA:
				return 'Ver extrato';
			case PixNotificationType.PIX_DEVOLUCAO_RECEBIDA:
				return 'Ver extrato';
			case PixNotificationType.PIX_REIVINDICACAO_ENVIADA:
				return 'Ver chaves';
			case PixNotificationType.PIX_REIVINDICACAO_RECEBIDA:
				return 'Ver extrato';
			case PixNotificationType.PIX_AGENDAMENTO_NAO_EFETIVADO:
				return 'Ver transações';
			case PixNotificationType.PIX_DEVOLVIDO_AGENDAMENTO_NAO_EFETIVADO:
				return 'Ver transações';
			case PixNotificationType.OPEN_BANKING_CONSENTIMENTO_PAGAMENTO:
				return 'Ver transações';
			case PixNotificationType.RECEBIMENTO_INFRACAO:
				return 'Ver extrato';
			case PixNotificationType.TRANSACAO_PAGAMENTO_CANCELADA:
				return 'Ver transações';
			case PixNotificationType.PIX_RECEBIDO_SOB_ANALISE_ANTIFRAUDE:
				return 'Ver detalhes'
			default:
				return '';
		}
	}

	getButtonLink(pixNotificationType: PixNotificationType): string {
		switch (pixNotificationType) {
			case PixNotificationType.PIX_ENVIADO:
				return '/pix';
			case PixNotificationType.PIX_RECEBIDO:
				return '/pix';
			case PixNotificationType.PIX_DEVOLUCAO_ENVIADA:
				return '/pix';
			case PixNotificationType.PIX_DEVOLUCAO_RECEBIDA:
				return '/pix';
			case PixNotificationType.PIX_REIVINDICACAO_ENVIADA:
				return '/pix/chaves/listar';
			case PixNotificationType.PIX_REIVINDICACAO_RECEBIDA:
				return '/pix';
			case PixNotificationType.PIX_AGENDAMENTO_NAO_EFETIVADO:
				return '/transacoes';
			case PixNotificationType.PIX_DEVOLVIDO_AGENDAMENTO_NAO_EFETIVADO:
				return '/transacoes';
			case PixNotificationType.OPEN_BANKING_CONSENTIMENTO_PAGAMENTO:
					return '/transacoes';
			case PixNotificationType.RECEBIMENTO_INFRACAO:
				return '/pix';
			case PixNotificationType.TRANSACAO_PAGAMENTO_CANCELADA:
				return '/transacoes';
			default:
				return '';
		}
	}

	deleteDetail(id) {
		this.notificationService.deleteNotification(id).subscribe( data => {
			this.deleteNotification = data;

			if (data.Sucesso) {
				this.loadNotifications();
				this.closeDetail();
			} else {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Não foi possível deletar essa notificação' });
			}

		});
	}

	openDetail() {
		TweenMax.to('.message-detail', .8, { left: 0, ease: Quint.easeOut });
	}

	closeDetail() {
		TweenMax.to('.message-detail', .8, { left: 600, ease: Quint.easeOut });
	}

	openAntifraudScreen(){
		if(this.detailNotification.pixNotification && this.detailNotification.pixNotification.contaNotificacaoPixTransferenciaRecebidaSobAnalise){
			this.setDataAntifraudScreen(this.detailNotification.pixNotification);
			this.router.navigate(['/aviso']);
			return;
		}
		
		this.router.navigateByUrl(this.detailNotification.buttonLink);
	}

	setDataAntifraudScreen(notification: PixNotification): void {
		this.antifraudWarning.name = Util.camelCaseText(notification.contaNotificacaoPixTransferenciaRecebidaSobAnalise.nomeDoPagador);
		this.antifraudWarning.value = notification.contaNotificacaoPixTransferenciaRecebidaSobAnalise.valor;
		this.antifraudWarning.date = moment(notification.dataNotificacao).format('DD/MM/YYYY');
		this.antifraudWarning.antifraudLabel = 'Transferência recebida por:' ;
		this.antifraudWarning.antifraudTitle = "Para sua segurança, o valor recebido abaixo está em análise!";
		this.antifraudWarning.showAntifraudScreen = true;
		this.antifraudWarningService.antifraudData = this.antifraudWarning;
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/notifications/notifications.component.ts